import { useState } from 'react'
import { Grid } from '@mui/material'

import GridIconButton from './GridIconButton'
import GridInputField from './GridInputField'

const GridLinkHomepage = ({ values, onChange = () => {} }) => {
  const [newLink, setNewLink] = useState()

  const cSetNewLink = (field, value) =>
    setNewLink({ ...newLink, [field]: value })

  const addSlot = () => {
    onChange((values || [])?.concat(newLink))
    setNewLink()
  }

  if (!newLink)
    return (
      <GridIconButton
        type='add'
        size={12}
        noCenter
        iconSize='small'
        onClick={() => setNewLink({})}
        text='Nuovo link'
      />
    )

  return (
    <Grid container spacing={2} alignItems='center' sx={{ width: '100%' }}>
      <GridInputField
        label='Titolo'
        field='titolo'
        value={newLink?.titolo}
        onChange={cSetNewLink}
        md={4}
      />
      <GridInputField
        label='URL'
        field='url'
        value={newLink?.url}
        onChange={cSetNewLink}
        md={6}
      />
      <GridIconButton
        type='save'
        size={{ xs: 6, md: 1 }}
        onClick={addSlot}
        disabled={!newLink?.titolo || !newLink?.url}
      />
      <GridIconButton
        type='clear'
        size={{ xs: 6, md: 1 }}
        onClick={() => setNewLink()}
      />
    </Grid>
  )
}

export default GridLinkHomepage
